import { render } from "./Menu.vue?vue&type=template&id=5f35e1bb"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
script.render = render

export default script